import * as React from 'react';
import DraftColumnOptions from './DraftColumnOptions';
import DraftColumnPlayer from './DraftColumnPlayer';
import styled from 'styled-components';
import { SortableContainer } from 'react-sortable-hoc';
class DraftColumn extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isRemovingPlayers: false
        };
        this.isSorting = false;
        this.onSortStart = () => {
            this.isSorting = true;
        };
        this.onSortEnd = ({ oldIndex, newIndex }) => {
            this.isSorting = false;
            this.props.handlers.updatePlayerOrder(this.props.playerPosition, oldIndex, newIndex);
        };
        this.toggleRemovePlayerModeHandler = () => {
            console.log("toggleRemovePlayerMode");
            this.setState(prevState => {
                return {
                    isRemovingPlayers: !prevState.isRemovingPlayers
                };
            });
        };
        this.handlers = {
            toggleRemovePlayerMode: this.toggleRemovePlayerModeHandler
        };
    }
    render() {
        console.log("render [DrafColumn]", this.props.playerPosition);
        const SortableList = SortableContainer(({ players }) => {
            return (React.createElement(List, null, players.order.map((playerId, index) => (React.createElement(DraftColumnPlayer, { isRemovingPlayers: this.state.isRemovingPlayers, disabled: this.state.isRemovingPlayers, isSorting: this.isSorting, index: index, key: playerId, handlers: Object.assign({}, this.props.handlers, this.handlers), playerColumnPosition: this.props.playerPosition, player: this.props.players.info[playerId] })))));
        });
        return (React.createElement(DraftColumnStyle, null,
            React.createElement(DraftColumnTitleStyle, null,
                React.createElement("h2", null, this.props.title),
                React.createElement(DraftColumnOptions, { playerPosition: this.props.playerPosition, handlers: Object.assign({}, this.props.handlers, this.handlers), isRemovingPlayers: this.state.isRemovingPlayers })),
            React.createElement(SortableList, { players: this.props.players, onSortStart: this.onSortStart, onSortEnd: this.onSortEnd })));
    }
}
;
export default DraftColumn;
const DraftColumnStyle = styled.div `
  background-color: rgba(0,0,0,0.7);
  display: inline-block;
  flex-grow: 1;
  margin: 0 0;
`;
const DraftColumnTitleStyle = styled.div `
  background-color: rgba(0,0,0,0.7);
  padding: 10px;
  
  h2 {
    display: inline-block;
    padding: 0;
    margin: 0;
  }
`;
const List = styled.ul `
  list-style: none none outside;
  margin: 0;
  padding: 0;
`;
//# sourceMappingURL=DraftColumn.js.map


// WEBPACK FOOTER //
// ./src/components/DraftColumn.js